import { entityRowsSelector } from './selectors';
import { ApplicationState } from 'app/types-store';
import { createDownloader } from 'app/infrastructure/platform/browser';
import { fetchAttachment } from 'app/infrastructure/remote-data/http';
import { endpoint } from 'app/area/case/endpoints';
import { UploadedFile } from './file-upload';
import { connect } from 'react-redux';
import { getChildEntitiesFromPath } from 'app/area/case/features/resolvers';
import { getEntityTypeFromPath } from 'app/infrastructure/store/entity';

export interface FileDownloadContainerProps {
  uploadedFiles?: UploadedFile[];
  createDownloader?: (blobId: number, name: string) => Promise<void>;
  loadBlob?: (blobId: number, thumbnail?: boolean) => Promise<Blob>;
}

export const withFileDownload = (entityTypeOverride?: string) => (component: any, uiEngineProps: any) => {
  const stateToProps = (state: ApplicationState): Partial<FileDownloadContainerProps> => {
    const hostProps = uiEngineProps.hostProps();
    const currentCaseNumber = hostProps.caseNumber;
    const isEditing = !!hostProps.editing;
    
    // Don't show attachments while fetching or when selectedId is undefined
    const isFetching = state?.caseArea?.fetching;
    const selectedId = state?.caseArea?.selectedId;
    
    // CRITICAL: Only show attachments if selectedId matches current case number
    // This prevents showing old case attachments when switching cases
    const caseMatches = isEditing || selectedId === currentCaseNumber;
    
    if (isFetching || selectedId === undefined || !caseMatches) {
      return {
        uploadedFiles: []
      };
    }

    const entityType = entityTypeOverride || getEntityTypeFromPath(uiEngineProps.componentDescriptor.entityTypePath);
    const entities = getChildEntitiesFromPath(state, uiEngineProps, 0, entityType);

    const rows = entityRowsSelector(entities, entityType);

    return {
      uploadedFiles: rows.sort((a, b) => b.id - a.id)
    };
  };

  const dispatchToProps = (dispatch: any): Partial<FileDownloadContainerProps> => {
    const hostProps = uiEngineProps.hostProps();
    const isEditing = !!hostProps.editing;
    const id = isEditing ? hostProps.entityId : hostProps.caseNumber;
    const documentUrl = endpoint.document(isEditing, id);

    return {
      createDownloader: createDownloader(documentUrl),
      loadBlob: fetchAttachment(documentUrl)
    };
  };

  return connect<any, any, any>(stateToProps, dispatchToProps)(component);
};
